import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Button, useLocalizeMessage, Icon } from 'libs.nucleus';
import { ImageUploadModal } from './image_upload_modal';
import { useBooleanState } from '../../../hooks';
import { FormatterWrapper } from '../formatters/formatter_wrapper';
export const ImageUpload = ({ onUpload, uploader = () => null }) => {
    const t = useLocalizeMessage();
    const [isImageUploadModalOpen, openImageUploadModal, closeImageUploadModal] = useBooleanState(false);
    const [canceled, setCanceled] = useState(false);
    const onOpen = useCallback(() => {
        setCanceled(false);
        openImageUploadModal();
    }, []);
    const onClose = useCallback((canceled) => {
        setCanceled(!!canceled);
        closeImageUploadModal();
    }, []);
    return (_jsxs(FormatterWrapper, { children: [_jsx(Button, { label: t('Upload image'), variant: 'transparent', type: 'button', size: 'full', content: _jsx(Icon, { name: 'image', size: 20, color: 'black' }), onClick: onOpen, disabled: false }), _jsx(ImageUploadModal, { isOpen: isImageUploadModalOpen, onClose: onClose, onUpload: onUpload, uploader: uploader, canceled: canceled })] }));
};
